import React, {FC} from 'react';
import {IconsName} from '@fkhplus/common/src/components/atoms/icon/icon';
import {
    Container,
    StyledIcon,
    ButtonText,
    Content,
    DescriptionText
} from '@fkhplus/common/src/components/atoms/Button/styles';
import { IButtonProps, IconPosition } from '@fkhplus/common/src/components/atoms/Button/interface';

export enum ButtonType {
    primary = 'primary',
    secondary = 'secondary',
    disable = 'disable',
    light = 'light',
    primaryLight = 'primaryLight',
    secondaryLight = 'secondaryLight'
}


const Button: FC<IButtonProps> = (props): React.ReactElement => {
    const {
        multiColorIconLeft,
        multiColorIconRight,
        iconName,
        iconPosition,
        title,
        iconSize,
        disabled,
        textStyle,
        onPress,
        onPressIconLeft,
        onPressIconRight,
        children,
        description,
        descriptionStyle,
    } = props;

    return (
        <Container onPress={onPress} disabled={disabled} styleProp={props}>
            <Content styleProp={props}>
                {children ? children :
                    <>
                        {!!multiColorIconLeft && multiColorIconLeft}
                        {iconPosition === IconPosition.Left &&
                            <StyledIcon onPress={onPressIconLeft} styleProp={props} size={iconSize ?? 15}
                                        name={iconName ?? IconsName.reorder}/>}
                        {!!title &&
                            <ButtonText
                                styleProp={props}
                                textStyle={{...textStyle}}
                            >
                                {title}
                            </ButtonText>}
                        {iconPosition === IconPosition.Right &&
                            <StyledIcon onPress={onPressIconRight} styleProp={props} size={iconSize ?? 15}
                                        name={iconName ?? IconsName.reorder}/>}
                        {multiColorIconRight != undefined && multiColorIconRight}
                    </>
                }
            </Content>
            {description && <DescriptionText textStyle={{...descriptionStyle}}>{description}</DescriptionText>}
        </Container>
    )
}

export default Button;